export async function fetchCancelContract(data: CancelContractData) {
  const route = useRoute()
  const locale = route.params.locale as string
  const runtimeConfig = useRuntimeConfig()
  const client = runtimeConfig.public.client

  return await $fetch
    .raw('/customer/cancelContract', {
      baseURL: useRuntimeConfig().public.apiBaseURL,
      method: 'PATCH',
      credentials: 'include',
      body: {
        customerData: {
          email: data.email,
          reasonUid: data.reason,
          firstName: data.firstName,
          lastName: data.lastName,
          ...(data.textarea !== '' && { comment: data.textarea }),
        },
        contractNumber: data.customerNumber,
        language: locale,
        client: client,
      },
    })
    .catch((error) => {
      return error.data
    })
}
